export enum TypeaheadBasketShowServicesEnum {
  ALL,
  EXTERNAL,
  INTERNAL,
}
